export default __webpack_public_path__ + "static/media/640_store04-jp-web.981af1e9.png";